import { skeletonPrefixCls } from "@/base/components/skeleton/Skeleton.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Skeleton">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${skeletonPrefixCls}`]: {},
  },
});

export const useSkeletonStyle = genComponentStyleHook(
  ["Skeleton", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
